import React, { Component } from 'react'
import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faThumbsDown } from '@fortawesome/free-solid-svg-icons'

import styles from './Confirmation.css'


class Confirmation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      remain: 0,
      reported: false,
    }
    this.timerId = null
  }

  componentDidMount() {
    this.refresh()
  }

  componentDidUpdate(prevProps) {
    if (this.props.started === prevProps.started) {
      return
    }
    this.setState({
      reported: false,
    }, () => this.refresh())
  }

  componentWillUnmount() {
    if (!this.timerId) {
      return
    }
    clearTimeout(this.timerId)
    this.timerId = null
  }

  refresh() {
    if (!this.props.started) {
      return
    }
    this.timerId = setTimeout(() => {
      const spentRate = (Date.now() - this.props.started) / this.props.duration
      const remain = Math.min(Math.max((1.0 - spentRate) * 100, 0), 100)
      this.setState({
        remain,
      }, () => {
        if (remain <= 0) {
          return
        }
        this.refresh()
      })
    }, 50)
  }

  problemReported() {
    this.setState({
      reported: true,
    })
    if (!this.props.problemReported) {
      return
    }
    this.props.problemReported()
  }

  renderExample() {
    const example = []
    let prev = null
    this.props.example.forEach(word => {
      if (prev && (prev.match(/^\'?[a-zA-Z0-9]+.*$/) || prev.match(/^[.,!?]+$/))
        && word.match(/^[a-zA-Z0-9]+.*$/)) {
        example.push(' ')
      }
      example.push(word)
      prev = word
    })
    const emphasize = example
      .filter((word) => word.toLowerCase().startsWith(this.props.word.toLowerCase()))
      .map((word) => [word, word.length - this.props.word.length])
    emphasize.sort((w1, w2) => w1[1] - w2[1])
    return example.map((word) => word === (emphasize[0] || [])[0] ?
      <strong>{word}</strong> : <span>{word}</span>)
  }

  render() {
    const fillerStyles = {
      height: '100%',
      width: `${this.state.remain}%`,
      backgroundColor: '#007bff',
      borderRadius: 'inherit',
    }
    return <div className={styles.Confirmation}>
      <div className={styles.ConfirmationProgress}>
        <div style={fillerStyles}></div>
      </div>
      <div>
        単語と意味を確認しましょう！
      </div>
      {this.props.example && <div className={styles.Example}>
          <Alert variant='secondary'>
            <div className={styles.ExampleHeader}>例:</div>
            {this.renderExample()}
          </Alert>
        </div>}
      {!this.props.disableProblemReport &&
        <div className={styles.BadProblem}>
          <Button
            disabled={this.state.reported}
            onClick={() => this.problemReported()}
            variant='warning'
            >
            問題の誤りを報告{this.state.reported && 'しました'}
            <FontAwesomeIcon icon={faThumbsDown} />
          </Button>
        </div>}
    </div>
  }
}

export default Confirmation
